var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chart',{staticClass:"chart_market_value",attrs:{"options":_vm.line},on:{"datazoom":function($event){return _vm.onDataZoom($event,_vm.line)}}}),_c('b-alert',{attrs:{"show":"","variant":"light"}},[_c('ul',[_c('li',[_vm._v("配合主图看，没啥大用")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }